import AppRouter from "./router/routes";
import { ToastContainer } from "react-toastify";
import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/css/base.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import whatsappIcon from "./assets/images/whatsapp.webp";
import { useTranslation } from "react-i18next";

function App() {
    const { t, i18n } = useTranslation();
  
  useEffect(() => {
 
    AOS.init({ duration: 1200, once: false });
  }, []);

  return (
    <div>
      <ToastContainer />
      <AppRouter />
      <a
        href="https://wa.me/971543655595"
        target="_blank"
        rel="noopener noreferrer"
        className={i18n.language === "ar" ? "whatsapp-float-a":"whatsapp-float"}
      >
        <img
          src={whatsappIcon} // replace with your WhatsApp icon path
          alt="WhatsApp"
          className="whatsapp-icon"
        />
      </a>
    </div>
  );
}

export default App;
